import React, { useEffect, useState } from 'react'
import { motion } from 'framer-motion'
// import { images } from '../../constants'
import './About.scss'
import { urlFor, client } from '../../client'
import { AppWrap, MotionWrap } from '../../wrapper'
//remove the static abouts array
// const abouts = [
//   { title: 'Web Development', description: 'I am a web developer with a passion for creating beautiful and functional websites', imgUrl: images.about01 },
//   { title: 'Graphic Design', description: 'I am a graphic designer with a passion for creating beautiful and functional designs', imgUrl: images.about02 },
//   { title: 'React JS', description: 'I am a digital marketer with a passion for creating effective marketing campaigns. ', imgUrl: images.about03 }
// ]
const About = () => {
  const [abouts, setAbouts] = useState([])
  //setup useEffect to run only when the component mounts, so remove the dependency array
  useEffect(() => {
    const query = '*[_type == "abouts"]';
    client.fetch(query)
      .then((data) => { setAbouts(data) })
  },[]);

  return (
    <>
      <h2 className='head-text'>I Know That <span>Good Dev</span>
        <br />
        means <span>Good Business</span>
      </h2>
      <div className='app__profiles'>
        {/*we want to dyna,ically loop over our abouts */}
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: 'tween' }}
            className='app__profile-item'
            key={about.title + index}>
             {/* Check if imgUrl is available before trying to render the image */}
             {about.imgUrl ? (
              <img src={urlFor(about.imgUrl)} alt={about.title} />
            ) : (
              <img src="/path/to/placeholder-image.jpg" alt="Placeholder" />
            )}
            <h2 className='bold-text' style={{ marginTop: 20 }}>{about.title}</h2>
            <p className='p-text' style={{ marginTop: 10 }}>{about.description}</p>
          </motion.div>
        ))}
      </div>

    </>
  )
}

export default AppWrap(
  
  MotionWrap(About,'app__about'), 'about','app__whitebg'

);
